import { Route } from '@/core/types';
import { subscriptions } from './routes';
import Subscriptions from '@/core/pages/Subscriptions/Subscriptions';
import SubscriptionsGuard from '@/features/subscriptions/components/SubscriptionsGuard';

const subscriptionsRoutes: Route = {
  ...subscriptions,
  element: <SubscriptionsGuard />,
  routes: [
    {
      ...subscriptions,
      element: <Subscriptions />,
    },
  ],
};

export default [subscriptionsRoutes];
